import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { isBoolean } from "lodash";
import { Observable } from "rxjs";
import { CanComponentDeactivate } from "../interfaces/deactivate.component";
import { AsyncModalService } from "./shared/async-modal-service";

@Injectable({ providedIn: "root" })
export class CanNavDeactivateService
    implements CanDeactivate<CanComponentDeactivate> {
    ignore: boolean = false;
    private asyncModalService: AsyncModalService;

    constructor(asyncModalService: AsyncModalService) {
        this.asyncModalService = asyncModalService;
    }

    async canDeactivate(component: CanComponentDeactivate) {
        if (this.ignore || !component || !component.canDeactivate) {
            return new Promise<boolean>((resolve) => {
                return resolve(true);
            });
        }
        let retValue = component.canDeactivate();

        if (retValue instanceof Observable)
            return await this.intercept(retValue);
        else if (retValue instanceof Promise) return await retValue;
        else return retValue;
    }

    private async intercept(observable: Observable<any>): Promise<boolean> {
        var res = await observable.toPromise();

        if (isBoolean(res) && !res)
            return await this.asyncModalService.getModalResponse(
                "Are you sure you want to leave this page without saving?",
                [
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                ]
            );
        else return res;
    }
}
